/* unknown.control_adapter.js */

var EventEmitter = require("events").EventEmitter;
var util = require("util");
var _ = require("lodash");
/**
 * @event UnknownControlAdapter#ValueChanged
 * @type {Object}
 * @property oldValue {string} The previous value
 * @property newValue {string} The new value
 */

/**
 * @class UnknownControlAdapter
 * @classdesc exposes the gl_textfield as a Form Control.
 * @implements ControlAdapterInterface
 *
 * @param logger {Bunyan} The logger
 * @param containingElem {DomElement} The containing dom element for this control
 * @param formCtrlDef {FormControlDefinition} The definition of this control object.
 *
 * @requires util
 * @requires EventEmitter
 *
 * @fires UnknownControlAdapter#ValueChanged
 */
module.exports = function (logger, containingElem, formCtrlDef) {
    var self = this;

    var api = {};
    var settings = {};

    //call Event Emitter Constructor
    EventEmitter.call(this);

    //The name of the control
    this.name = formCtrlDef.name;

    /**
     * @returns the data associated with this control.
     */
    this.getValue = function () {
        return formCtrlDef.value;
    };

    /**
     * Set this controls current value.
     * @param val {*} The value to set this control to.
     * @returns the value associated with this control, it might not always be the same as the value passed in for
     * example adapters with a ValueScope.PARENT.
     */
    this.setValue = function (val) {
        //no Value Changed Events fired from this control adapter
        //So lets update the value ourselves
        formCtrlDef.value = val;
    };

    /**
     * Tear down this control
     */
    this.tearDown = function () {
        //nothing to clean up
    };

    /**
     * An Initialization function. Called by the form renderer when this control should be initialized.
     */
    this.init = function () {
        //Render content
        containingElem.append(
            "<p>Cannot be rendered at this point. (" + formCtrlDef.name + ")</p>"
        );

        self.emit("InitializationComplete", {
            initializedValue: self.getValue(),
        });
    };
};

//Make this API inherit from EventEmitter
util.inherits(module.exports, EventEmitter);
